export default __webpack_public_path__ + "0b826ef8e2023cd96c9ad0ea43814bfa.svg";